import { width } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";

const muiTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "var(--theme-surface-2)",
          "&.MuiButton-root": { color: "var(--theme-text)" },
        },
        outlined: { borderColor: "var(--theme-border)" },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: { color: "var(--theme-text)" },
      },
    },

    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            backgroundColor: "var(--theme-table-heading)",
            color: "var(--theme-table-heading-contrast)",
            borderColor: "var(--theme-table-heading-border)",
            fontWeight: 600,
          },
        },
      },
    },

    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root:nth-of-type(odd)": { backgroundColor: "var(--theme-table-row-odd)" },
          "& .MuiTableRow-root:nth-of-type(even)": { backgroundColor: "var(--theme-table-row-even)" },
          "& .MuiTableRow-root:hover": { backgroundColor: "var(--theme-table-row-hover)" },
          "& .MuiTableCell-root": {
            color: "var(--theme-table-row-contrast)",
            borderColor: "var(--theme-table-border)",
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        icon: { color: "var(--theme-text-muted)" },
      },
    },

    MuiTabs: {
      styleOverrides: {
        indicator: { backgroundColor: "var(--theme-info-light)" },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: "var(--theme-text)",
          '&.Mui-disabled': {
            color: "var(--theme-text-muted)",
            WebkitTextFillColor: "var(--theme-text-muted)"
          }
        },
        notchedOutline: { borderColor: "var(--theme-border)" },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          backgroundColor: "var(--theme-surface-2)",
          color: "var(--theme-text)",
        },
        clearIndicator: {
          color: "var(--theme-text)",
        },
        popupIndicator: {
          color: "var(--theme-text)",
          '&.Mui-disabled': { color: "var(--theme-text-muted)" }
        },
        option: {
          color: "var(--theme-text)",
          backgroundColor: "var(--theme-surface-2)"
        },
        root: {
          "& .MuiFormLabel-root": { color: "var(--theme-text)" },
          "&.Mui-focused .MuiFormLabel-root": {
            backgroundColor: "var(--theme-surface-2)",
            color: "var(--theme-text)"
          },
          "& .MuiChip-deleteIcon": { color: "var(--theme-text) !important" },
        },
        listbox: {
          backgroundColor: "var(--theme-surface-2)",
          color: "var(--theme-text)",
          border: "1px solid var(--theme-table-border)",
          "& .MuiAutocomplete-option": { borderBottom: "1px solid var(--theme-border)" },
          "& .MuiAutocomplete-option.Mui-focused": { backgroundColor: "var(--theme-surface)" },
        }
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": { color: "var(--theme-text)" },
          backgroundColor: "var(--theme-surface-2)",
          borderColor: "var(--theme-border)",
          '& .Mui-disabled.MuiFormLabel-root': {
            color: "var(--theme-text-muted) !important"
          },
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "var(--theme-surface-2)",
          color: "var(--theme-text)",
          borderColor: "var(--theme-border)",
        },
      },
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: { color: "var(--theme-text)" },
      },
    },

    MuiDialogContent: {
      styleOverrides: {
        root: { color: "var(--theme-text)" },
      },
    },

    MuiDialogActions: {
      styleOverrides: {
        root: { borderTop: "1px solid var(--theme-border)" },
      },
    },

    MuiFormControlLabel: {
      styleOverrides: {
        label: { color: "var(--theme-text)" },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: { color: "var(--theme-text-muted)" },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiFormLabel-root': {
            color: "var(--theme-text)",
            borderColor: "var(--theme-border)",

          },
          '& .MuiPickersInputBase-sectionsContainer': {
            color: "var(--theme-text)",
            width: "65px"
          },
          '& .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: "var(--theme-border)"
          },
          '& .MuiButtonBase-root': {
            color: "var(--theme-text)",
          },
        }
      }
    }
  },
});

export function AppMuiProvider({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}